var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ratio)?_c('figure',{staticClass:"image",class:_vm.ratio ? 'ratio-' + _vm.ratio : '',style:('background-image:url(' + _vm.src + ');')}):_c('img',{staticClass:"image",attrs:{"src":_vm.src}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d547156","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/components/image.vue
// module id = null
// module chunks = 